import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private actionsClickSubject = new Subject<void>();
  private sidebarToggleSubject = new Subject<void>();

  constructor() {}

  triggerActionsClick() {
    this.actionsClickSubject.next();
  }

  getActionsClickObservable() {
    return this.actionsClickSubject.asObservable();
  }

  triggerSidebarToggle() {
    this.sidebarToggleSubject.next();
  }

  getSidebarToggleObservable() {
    return this.sidebarToggleSubject.asObservable();
  }
}
